import { render, staticRenderFns } from "./Suggestions.vue?vue&type=template&id=9e4752a2&scoped=true"
import script from "./Suggestions.vue?vue&type=script&lang=js"
export * from "./Suggestions.vue?vue&type=script&lang=js"
import style0 from "./Suggestions.vue?vue&type=style&index=0&id=9e4752a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4752a2",
  null
  
)

export default component.exports